import { NgModule, ModuleWithProviders } from '@angular/core';
import {TestService} from './test.service';


export class TestModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: TestModule,
            providers: [TestService] 
        }
    }
 static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
